const scheduleContact = {
    scheduleContact: {
        pageTitle: 'Schedule a Contact',
        pageDescription: 'You can look up your satellite and communication schedules and schedule access to your satellite.',
        alertMessage: 'For accurate communication, we recommend that you update to the latest TLE immediately before contact.',
        button: {
          search: 'Search'
        },
        checkout: {
          plan: 'Plan',
          price: 'Price',
          discount: 'Discount',
          selected: 'Selected',
          total: 'Total',
          checkout: 'Checkout'
        }
        
    }
}

export default scheduleContact;